import React, { useState } from 'react'

export const ContractBuilderContext = React.createContext()

export const defaultTableSort = {
  parameter: null,
  direction: null
}
export function ContractBuilderProvider({
  children,
  skipCostOnPeriodsChange,
  contractId,
  defaultAdditionalInfoEdit = false
}) {
  const [editProductId, setEditProductId] = useState(null)
  const [isAdditionalInfoEdit, setIsAdditionalInfoEdit] = useState(defaultAdditionalInfoEdit)
  const [tableSort, setTableSort] = useState(defaultTableSort)

  // this helps to provide list of ids of bulk added products to pass in onSubmit form for proposals
  const addedProductsIdsRef = React.useRef([])

  return (
    <ContractBuilderContext.Provider
      value={{
        contractId,
        editProductId,
        addedProductsIdsRef,
        setEditProductId,
        isAdditionalInfoEdit,
        setIsAdditionalInfoEdit,
        tableSort,
        setTableSort,
        skipCostOnPeriodsChange
      }}
    >
      {children}
    </ContractBuilderContext.Provider>
  )
}
